export type ServiceDrugType = {
  title: string;
  subtitle: string;
  icon?: string;
  createAccountTitle: string;
  createAccountSubTitle: string;
};

export const serviceDrugsOptions = {
  ED: [
    {
      title: 'Sildenafil (generic Viagra)',
      subtitle: 'The most common medication. Usually taken prior to sexual activity.',
      icon: '/images/icons/drugsOptions/pill-blue.svg',
      createAccountTitle: 'Sildenafil Prescription',
      createAccountSubTitle: 'Available for same-day pharmacy pickup or convenient, discreet delivery.',
    },
    {
      title: 'Tadalafil (generic Cialis)',
      subtitle: 'Similar to sildenafil but can last longer. Taken as needed or daily.',
      icon: '/images/icons/drugsOptions/pill-yellow.svg',
      createAccountTitle: 'Tadalafil Prescription',
      createAccountSubTitle: 'Available for same-day pharmacy pickup or convenient, discreet delivery.',
    },
    {
      title: 'Vardenafil (generic Levitra)',
      subtitle: 'A newer medicine similar to sildenafil and tadalafil. Usually taken prior to sexual activity.',
      icon: '/images/icons/drugsOptions/pill-orange.svg',
      createAccountTitle: 'Vardenafil Prescription',
      createAccountSubTitle: 'Available for same-day pharmacy pickup.',
    },
    {
      title: 'No preference / Not sure',
      subtitle: 'Our experienced health providers can help you decide which medication is best for you.',
      createAccountTitle: 'ED Medication',
      createAccountSubTitle: 'Get a personalized treatment plan from an experienced, licensed healthcare provider.',
    },
  ],
  BIRTH_CONTROL: [
    {
      title: 'Pill',
      subtitle:
        'Most popular and lowest-cost option. Taken daily, one pack contains a three- or four-week schedule of pills.',
      icon: '/images/icons/drugsOptions/tablets.svg',
      createAccountTitle: 'Birth Control Pills',
      createAccountSubTitle:
        'We prescribe all major brands and generics. Available for same-day pharmacy pickup or convenient delivery.',
    },
    {
      title: 'Patch',
      subtitle: 'Applied directly to your skin. Worn for three consecutive weeks, changed weekly.',
      icon: '/images/icons/drugsOptions/patch.svg',
      createAccountTitle: 'Birth Control Patch',
      createAccountSubTitle:
        'Get help with your patch prescription now with one of our experienced, licensed medical providers.',
    },
    {
      title: 'Ring',
      subtitle: 'Placed directly inside the vagina. Only needs to be changed once a month.',
      icon: '/images/icons/drugsOptions/ring.svg',
      createAccountTitle: 'Birth Control Ring',
      createAccountSubTitle:
        'Get help with your ring prescription now with one of our experienced, licensed medical providers.',
    },
    {
      title: 'No preference / Not sure',
      subtitle: 'Our experienced health providers can help you decide which method is best for you.',
      createAccountTitle: 'Birth Control',
      createAccountSubTitle: 'Get birth control recommendations from an experienced, licensed healthcare provider.',
    },
  ],
};
